import { useMsal } from "@azure/msal-react";
import { Box, Button, Menu, MenuItem, useTheme } from "@mui/material";
import { Person, KeyboardArrowDown } from "@mui/icons-material";
import { useState } from "react";
import { msalInstance } from "../services/authConfig";

const Header = () => {
  const theme = useTheme();
  const { accounts } = useMsal();
  const username = accounts[0]?.name || "User";

  const [userAnchor, setUserAnchor] = useState<null | HTMLElement>(null);

  const handleLogout = async () => {
    const account = msalInstance.getAllAccounts()[0];

    await msalInstance.logoutRedirect({
      account,
      postLogoutRedirectUri: "/login",
    });
  };

  return (
    <Box
      sx={{
        minWidth: "100%",
        height: "61px",
        background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 250%)`,
        display: "flex",
        alignItems: "center",
        px: 2,
        mb: 4,
        justifyContent: "space-between",
        boxSizing: "border-box",
      }}
    >
      <Button>
        <img onClick={() => {}} src="assets/logo.svg" alt="Logo" height="24" />
      </Button>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <>
          <Button
            onClick={(e) => setUserAnchor(e.currentTarget)}
            sx={{ color: "white" }}
            endIcon={<KeyboardArrowDown />}
            startIcon={<Person />}
          >
            {username}
          </Button>
          <Menu
            anchorEl={userAnchor}
            open={Boolean(userAnchor)}
            onClose={() => setUserAnchor(null)}
          >
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </>
      </Box>
    </Box>
  );
};

export default Header;
